/* Character Builder (livre simple) — même format que le pack : 1 vidéo partagée + 3 options directes côte à côte
   (Rigide 20x20 / Souple 14x14 / Souple 20x20), sans étape intermédiaire "type de couverture" puis "taille". */
(function () {
  var VIDEO_URL = 'https://cdn.shopify.com/videos/c/o/v/751c87c27626448c8a861aac9bcb1701.mp4';

  var style = document.createElement('style');
  style.textContent = [
    '.cb-cover-video-shared { width:100%; max-width:380px; margin:0 auto 12px; border-radius:14px; overflow:hidden; border:1.5px solid #C1E5F1; aspect-ratio:16/10; }',
    '.cb-cover-video-shared video { width:100%; height:100%; object-fit:contain; display:block; }',
    '.cover-grid.cb-flat { grid-template-columns:repeat(3, 1fr) !important; gap:8px !important; max-width:600px; }',
    '.cover-grid.cb-flat .cover-option, .cover-grid.cb-flat .size-btn { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:12px 6px; text-align:center; gap:3px; border-width:2px; transition:all 0.25s; }',
    '.cover-grid.cb-flat .cover-icon { display:none; }',
    '.cover-grid.cb-flat .cover-name, .cover-grid.cb-flat .size-btn-name { font-size:12px; margin-bottom:2px; }',
    '.cover-grid.cb-flat .cover-price, .cover-grid.cb-flat .size-btn-price { font-size:9px; color:#888; font-weight:400; }',
    '.cb-badge { display:inline-block; width:auto; font-size:8px; font-weight:800; text-transform:uppercase; letter-spacing:0.6px; padding:2px 7px; border-radius:20px; color:white; margin-bottom:2px; }',
    '.cover-grid.cb-flat .cover-option:hover, .cover-grid.cb-flat .size-btn:hover { border-color:#C1E5F1 !important; transform:translateY(-2px); box-shadow:0 4px 14px rgba(193,229,241,0.3); }',
    '.cover-grid.cb-flat .cover-option.active, .cover-grid.cb-flat .size-btn.active { border-color:#8ECFE8 !important; border-width:2px !important; background:linear-gradient(160deg,#F2FAFD,#E8F6FC) !important; box-shadow:0 12px 28px rgba(193,229,241,0.55) !important; transform:none; }'
  ].join('\n');
  document.head.appendChild(style);

  function makeBadge(text, color) {
    var b = document.createElement('div');
    b.className = 'cb-badge';
    b.textContent = text;
    b.style.background = color;
    return b;
  }

  function buildFlatCover() {
    var stepCover = document.getElementById('stepCover');
    if (!stepCover) return;
    var grid = stepCover.querySelector('.cover-grid');
    if (!grid) return;

    if (!stepCover.querySelector('.cb-cover-video-shared')) {
      var vid = document.createElement('div');
      vid.className = 'cb-cover-video-shared';
      vid.innerHTML = '<video autoplay loop muted playsinline><source src="' + VIDEO_URL + '" type="video/mp4"></video>';
      grid.parentNode.insertBefore(vid, grid);

      var videoEl = vid.querySelector('video');
      if (videoEl) {
        var tryPlay = function () { videoEl.play().catch(function () {}); };
        var syncAspect = function () {
          if (videoEl.videoWidth && videoEl.videoHeight) {
            vid.style.aspectRatio = videoEl.videoWidth + '/' + videoEl.videoHeight;
          }
        };
        tryPlay();
        videoEl.addEventListener('loadedmetadata', function () { syncAspect(); tryPlay(); });
        videoEl.addEventListener('canplay', tryPlay);
      }
    }

    if (grid.dataset.cbFlattened) return;
    grid.dataset.cbFlattened = '1';
    grid.classList.add('cb-flat');

    var rigideOpt = grid.querySelector('.cover-option[data-cover="rigide"]');
    var soupleOpt = grid.querySelector('.cover-option[data-cover="souple"]');
    var sizeOptionsSouple = stepCover.querySelector('#sizeOptionsSouple');
    var sizeGrid = sizeOptionsSouple ? sizeOptionsSouple.querySelector('.size-grid') : null;

    grid.querySelectorAll('.cover-icon').forEach(function (i) { i.remove(); });

    if (rigideOpt && !rigideOpt.querySelector('.cb-badge')) {
      rigideOpt.insertBefore(makeBadge('RIGIDE', '#3A9DB8'), rigideOpt.firstChild);
    }

    /* La carte générique "Souple" est remplacée par les 2 cartes de taille ci-dessous */
    if (soupleOpt) soupleOpt.style.display = 'none';

    var sizeBtns = [];
    if (sizeGrid) {
      sizeBtns = Array.prototype.slice.call(sizeGrid.children);
      sizeBtns.forEach(function (btn) {
        if (!btn.querySelector('.cb-badge')) btn.insertBefore(makeBadge('SOUPLE', '#8ECFE8'), btn.firstChild);
        grid.appendChild(btn);
        /* Cliquer une carte de taille doit aussi sélectionner "souple" comme type de couverture */
        btn.addEventListener('click', function () {
          if (soupleOpt && !soupleOpt.classList.contains('active')) soupleOpt.click();
        });
      });
    }

    if (sizeOptionsSouple) sizeOptionsSouple.style.display = 'none';

    /* Une seule des 3 cartes visibles doit rester "active" à la fois — .cover-option et .size-btn
       ont chacun leur propre logique de sélection native et ne se désélectionnent pas entre eux. */
    var visibleCards = sizeBtns.slice();
    if (rigideOpt) visibleCards.push(rigideOpt);
    function enforceExclusive(selected) {
      visibleCards.forEach(function (el) {
        if (el !== selected) el.classList.remove('active');
      });
    }
    if (rigideOpt) rigideOpt.addEventListener('click', function () { enforceExclusive(rigideOpt); });
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { enforceExclusive(btn); });
    });
  }

  function init() {
    buildFlatCover();
    var cover = document.getElementById('stepCover');
    if (cover) new MutationObserver(buildFlatCover).observe(cover, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
